export const ErrorText = ({ text }: { text: string }) => {
  return (
    <span
      className="
          text-sm text-danger
          block pt-1 font-normal
          "
    >
      {text}
    </span>
  )
}
